import React, { useEffect, useMemo, useState } from "react";
import { Button, Input, ListGroup, ListGroupItem } from "reactstrap";

const defaultGetOptionValue = (option) => option.id;
const defaultGetOptionLabel = (option) => option.name;

const SearchableDropdownFilter = ({
    value,
    options,
    placeholder,
    disabled = false,
    getOptionValue = defaultGetOptionValue,
    getOptionLabel = defaultGetOptionLabel,
    onChange,
}) => {
    const [searchText, setSearchText] = useState("");
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const selected = (options || []).find(option => `${getOptionValue(option)}` === `${value}`);
        setSearchText(selected ? getOptionLabel(selected) : "");
    }, [value, options, getOptionValue, getOptionLabel]);

    const filteredOptions = useMemo(() => {
        const search = searchText.trim().toLowerCase();
        if (!search) return options || [];
        return (options || []).filter(option => getOptionLabel(option).toLowerCase().includes(search));
    }, [searchText, options, getOptionLabel]);

    const clearFilter = () => {
        setSearchText("");
        setOpen(false);
        onChange("");
    };

    const selectOption = (option) => {
        setSearchText(getOptionLabel(option));
        setOpen(false);
        onChange(`${getOptionValue(option)}`);
    };

    return (
        <div className="position-relative">
            <div className="input-group">
                <Input
                    placeholder={placeholder}
                    value={searchText}
                    disabled={disabled}
                    onFocus={() => setOpen(true)}
                    onBlur={() => setTimeout(() => setOpen(false), 150)}
                    onChange={(e) => {
                        const nextValue = e.target.value;
                        setSearchText(nextValue);
                        setOpen(true);
                        if (nextValue.trim() === "") {
                            onChange("");
                        }
                    }}
                />
                <Button
                    type="button"
                    color="secondary"
                    outline
                    disabled={disabled}
                    onMouseDown={(e) => e.preventDefault()}
                    onClick={() => setOpen(!open)}
                >
                    v
                </Button>
            </div>
            {open && !disabled && (
                <ListGroup className="position-absolute w-100" style={{ zIndex: 1000, maxHeight: 260, overflowY: "auto" }}>
                    {value && (
                        <ListGroupItem action onMouseDown={(e) => { e.preventDefault(); clearFilter(); }}>
                            Clear filter
                        </ListGroupItem>
                    )}
                    {filteredOptions.length === 0 ? (
                        <ListGroupItem disabled>No matches</ListGroupItem>
                    ) : (
                        filteredOptions.map(option => (
                            <ListGroupItem
                                key={getOptionValue(option)}
                                action
                                onMouseDown={(e) => { e.preventDefault(); selectOption(option); }}
                            >
                                {getOptionLabel(option)}
                            </ListGroupItem>
                        ))
                    )}
                </ListGroup>
            )}
        </div>
    );
};

export default SearchableDropdownFilter;
